export default {
  install(Vue) {
    Vue.component('controls', () => import(/* webpackChunkName: "player" */ './Controls'))
    Vue.component('shaka', () => import(/* webpackChunkName: "player" */ './Shaka'))
    Vue.component('episodes', () => import(/* webpackChunkName: "player" */ './Episodes'))
    Vue.component('fullscreen-btn', () => import(/* webpackChunkName: "player" */ './FullscreenButton'))
    Vue.component('timeline', () => import(/* webpackChunkName: "player" */ './Timeline'))
    Vue.component('volume', () => import(/* webpackChunkName: "player" */ './Volume'))
    Vue.component('player-footer', () => import(/* webpackChunkName: "player" */ './PlayerFooter'))
  }
}
